import { Component, computed } from '@angular/core';
import { TagFilterDto, TagItemDto, TagService } from '@artemis-software/wr-api';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { catalogReadOnlyBanner, catalogTenantId, isCatalogReadOnly } from '@/utils/admin-utils';
import { CurrentUserService } from '@services/current-user.service';

@Component({
  standalone: false,
  selector: 'wr-tag-overview-page',
  templateUrl: './tag-overview-page.component.html',
  styleUrls: ['./tag-overview-page.component.scss'],
})
export class TagOverviewPageComponent {
  canCreate = computed(() => this.currentUserService.hasPrivilege('canCreateTags'));
  readonly catalogReadOnly = isCatalogReadOnly();
  readonly catalogBanner = catalogReadOnlyBanner();
  tenantId = catalogTenantId();
  form!: FormGroup;

  readonly loadTags = (filter: TagFilterDto) => this.tagService.findAll({ ...filter, tenantId: this.tenantId() });
  readonly getCount = (filter: TagFilterDto) => this.tagService.getCount({ ...filter, tenantId: this.tenantId() });

  constructor(
    private readonly tagService: TagService,
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
    private readonly currentUserService: CurrentUserService
  ) {
    this.form = this.formBuilder.group({
      text: this.formBuilder.control(''),
    });
  }

  add(): void {
    this.router.navigate(['tag', 'new']);
  }

  navigateToTag(tag: TagItemDto): void {
    this.router.navigate(['tag', tag.id]);
  }
}
